import React from "react";
import { CheckboxEditor } from "../../../../../../../../../react-core/Html/CheckboxEditor";
import { FormComponent } from "../../../../../../../../../react-core/Html/FormComponent";
import { PartLoading } from "../../../../../../../../../react-core/Html/PartLoading";
import { RoleType } from "../../../../../../../../../Wrap/Constants/Enums/RoleType";
import { UserClaim } from "../../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { Permission } from "../../../../../../../../Shared/Permission/Permission";
import { portfolioDashboardRolesAction } from "../../Action/Action";
import { PermissionType } from "../../../../../../../../../Wrap/Constants/Enums/Apply/PermissionType";

interface IClientAccessProps {
    customerId: number;
    clAccountId: string;
    hierarchyId: string;
    roleType: RoleType;
}

interface IClientAccessState {
    isClientAccess: boolean;
    originalClientAccess: boolean;
    isEdit: boolean;
    isClientUserExist: boolean;
    PermissionType: PermissionType;
}

export class ClientAccess extends FormComponent<IClientAccessProps, IClientAccessState> {
    constructor(props: IClientAccessProps) {
        super(props);
        this.state = {
            isClientAccess: null,
            originalClientAccess: null,
            isEdit: false,
            isClientUserExist: null,
            PermissionType: PermissionType.NotSpecified
        };
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        const { customerId, clAccountId, roleType } = this.props;
        portfolioDashboardRolesAction.getClientAccess(customerId, clAccountId, roleType, (result) => {
            this.setState({
                isClientAccess: result.IsClientAccess,
                originalClientAccess: result.IsClientAccess,
                isClientUserExist: result.ClientUserId > 0,
                PermissionType: result.PermissionType
            });
        });
    }

    private saveSetting() {
        const { customerId, hierarchyId, roleType } = this.props;
        // if (this.state.isClientUserExist) return;
        this.setState({ isClientAccess: null, isEdit: false });
        portfolioDashboardRolesAction.updateClientAccess(
            {
                CustomerId: customerId,
                HierarchyId: hierarchyId,
                RoleType: roleType,
                IsClientAccess: this.state.isClientAccess,
                PermissionType: this.state.PermissionType
            },
            () => {
                this.getData();
            }
        );
    }

    public render(): JSX.Element {
        const { isClientAccess, isEdit, originalClientAccess, isClientUserExist } = this.state;
        if (isClientAccess == null) {
            return <PartLoading isLoading={true} />;
        }

        return (
            <>
                <h4>Client portal access</h4>
                {!isEdit && (
                    <dl className="def-list">
                        <dt>Read only access</dt>
                        <dd>{isClientAccess == true ? "Yes" : "No"}</dd>
                    </dl>
                )}
                {isEdit && (
                    <CheckboxEditor
                        label="Read only access"
                        cssWrapper="square-checkbox block mt-19"
                        value={isClientAccess}
                        onChange={(v) => this.setState({ isClientAccess: v, PermissionType: v ? PermissionType.ReadOnly : PermissionType.ReadWrite })}
                        disabled={!isEdit}
                    />
                )}
                <Permission userClaim={UserClaim.AdviserPortalCustomerPartialAccessReadWrite}>
                    <div>
                        <div className="row row-center">
                            {!isEdit && (
                                <div className="col-auto">
                                    <button
                                        className="edit-circle-icon-button label-sr-only"
                                        title="Edit"
                                        onClick={() => this.setState({ isEdit: true })}
                                    >
                                        <span className="icon" aria-hidden="true"></span>
                                        <span className="text">Edit</span>
                                    </button>
                                </div>
                            )}
                            {isEdit && (
                                <div className="col-auto">
                                    <button
                                        className="button mr-20"
                                        onClick={(val) =>
                                            this.setState({ isEdit: false, isClientAccess: originalClientAccess })
                                        }
                                    >
                                        Cancel
                                    </button>
                                </div>
                            )}
                            {isEdit && (
                                <div className="col-auto">
                                    <button className="button" onClick={(val) => this.saveSetting()}>
                                        Save
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </Permission>
            </>
        );
    }
}
